import styled, { css } from "styled-components";
import { Text, Heading, List } from "../../../services/visualLibraryService";
import { i18n } from "../../../services/i18nService";

export const SettingsPageStyled = styled.section`
  padding: ${props => props.theme.baseLayoutPaddingBs}%;
  padding-top: 3%;
`;

export const TextDisclaimerStyled = styled(Text)`
  // margin-top: ${props => props.theme.spacing.medium};
  letter-spacing: 0rem;
`;

export const BlockStyled = styled.div`
  & {
    width: 36%;
  }
  & + & {
    width: 57%;
    text-align: center;
  }
`;

export const HeadingStyled = styled(Heading)`
  margin-bottom: ${props => props.theme.spacing.small};
`;

export const ListInfoStyled = styled(List)`
  position: absolute;
  bottom: ${props => props.theme.baseLayoutPaddingBs * 2}%;
`;

export const LogoStyled = styled.div`
  ${props => `text-align: ${props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "left" : "right"}`};
  position: relative;
  height: 2.7vw;
`;

export const LogoImg = styled.img`
  width: 15.47vw;
  height: 8.055vh;
`;

export const ListStyled = styled.div`
  width: 98%;
  text-align: start;
  padding: 0.5rem 1rem 1rem 1rem;
  height: 6.5rem;
  margin: 0rem 0rem 1rem;
  p {
    margin-bottom: 0rem;
    line-height: 2.5rem;
  }
  p:first-child {
    color: ${props => props.theme.color.grey};
  }
  .keyHeading {
    line-height: 2.25rem;
  }
  border-radius: 0.5rem;
  background-color: rgba(0, 0, 0, 0.3);
`;

const wrapperStyles = {
  wrapperStyles: css`
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    > * {
      margin-bottom: 0.8rem;
    }
  `
};

export const ProfileWrapper = styled.div`
  ${wrapperStyles.wrapperStyles};
  width: 100%;
`;

export const LanguageWrapper = styled.div`
  ${wrapperStyles.wrapperStyles};
  width: 50%;
`;

export const LogoutWrapper = styled.div`
  ${wrapperStyles.wrapperStyles};
  width: 50%;
`;

export const DevicesWrapper = styled.div`
  ${wrapperStyles.wrapperStyles};
  width: 100%;
`;

export const ParentalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  width: 100%;
  > * {
    margin-bottom: 0.8rem;
  }

  .restricted {
    line-height: 1.2;
  }
`;

export const LineSeparator = styled.div`
  position: absolute;
  border-right: 2px solid ${props => props.theme.color.greyLight};
  top: 18vh;
  ${props => `${props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "right" : "left"}: 39rem`};
  height: 70vh;
  opacity: 0.2;
`;

export const Spacer = styled.div`
  margin-bottom: ${props => (props.mb ? `${props.mb}rem` : "2rem")};
`;

export const AccountStatusWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
`;

export const TextChannelsStyled = styled(Text)`
  margin-bottom: ${props => props.theme.spacing.xlarge};
`;
